import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { AlertOctagonIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Heading } from "@/components/ui/heading";
import { useTranslation } from "@/hooks/useTranslation";
import { PATHS } from "@/config/paths";

export function GlobalError({ error }: { error: Error }) {
  const { t } = useTranslation();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const backToDashboard = () => {
    // Should redirect to dashboard with a reload
    window.location.href = PATHS.DASHBOARD;
  };

  return (
    <div className="flex justify-center">
      <Card className="text-center">
        <CardHeader className="pb-0">
          <div className="flex flex-col items-center">
            <AlertOctagonIcon className="h-12 w-12 text-red-300 opacity-80 mb-2" />
            <Heading level="h1" size="h3">
              {t("global_error.title")}
            </Heading>
          </div>
        </CardHeader>
        <CardContent className="pt-0">
          <p className="mt-4 text-lg">{t("global_error.description")}</p>
          <p className="mt-2 text-gray-600">{t("global_error.team_notified")}</p>
          <Button
            className="mt-4"
            onClick={backToDashboard}
            data-umami-event="global-error-return-to-dashboard"
          >
            {t("global_error.refresh")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
